export default __webpack_public_path__ + "static/media/flipkartLogo.5949178b.svg";